module.exports = __webpack_public_path__ + "static/media/ind6ru.bb7787c2.pdf";